import React from 'react'

import { Colors, Icon, ProgressBar } from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'

import { useLaunchStrategyContext } from '../../contexts/LaunchStrategyContext'
import * as S from './LaunchStrategyContinueBar.styled'

export const LaunchStrategyContinueBar = () => {
  const {
    showContinueBar,
    data,
    progress,
    absoluteActiveGuideIndex,
    totalGuides,
    openModal,
    setShowContinueBar,
  } = useLaunchStrategyContext()

  const title = data.modal.categories[progress.category.index].guides[progress.guide.index].title

  return (
    <S.Container onClick={openModal} $visible={showContinueBar}>
      <ProgressBar
        value={absoluteActiveGuideIndex + 1}
        max={totalGuides}
        height={4}
        barColor={Colors.G300}
      />
      <S.Content>
        <S.TextualContent>
          <S.Label>Continue your launch guide:</S.Label>
          <S.Title>{title}</S.Title>
        </S.TextualContent>
        <S.CloseButton
          title="Close"
          onClick={(e) => {
            e.stopPropagation()
            setShowContinueBar(false)
          }}
        >
          <Icon component={CloseIcon} height={10} />
        </S.CloseButton>
      </S.Content>
    </S.Container>
  )
}
